<template>
  <div>
    <list-matches :tournament="tournament" @create="create()" @update="update" @remove="remove" @view="view"/>
    <form-match
      @close="close()"
      :Edit="edit"
      :modal="modal"
      :external-action="action"
      :external-match="matchSend"
      external-type="tournament"
    />
    <!-- <match-view @close="closeView()" :modal="viewModal"/> -->
  </div>
</template>

<script>
import listMatches from '../matches/list'
import formMatch from '../matches/formManager'
// import MatchView from "./MatchView";
import { mapActions, mapState } from 'vuex'
export default {
  name: 'tabMatches',
  components: {
    listMatches,
    formMatch
    // MatchView
  },
  props: {
    tournament: {
      type: Object,
      required: false,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      modal: false,
      action: 'create',
      edit: true,
      viewModal: false
    }
  },
  mounted () {
    // this.initData();
  },
  computed: {
    ...mapState({
      matchSend: state => state.matches.matchSelected,
      statusOfButton: state => state.events.status
    })
  },
  methods: {
    ...mapActions({
      getOne: 'matches/setOne',
      setOneActByScore: 'acts/setOneByScore',
      clearOneActs: 'acts/setClearOne',
      clearOne: 'matches/setClearOne',
      aspectsInit: 'aspects/setInit',
      actsInit: 'acts/setInit',
      entitiesInit: 'entities/setInit',
      tournamentsInit: 'tournaments/setInit',
      // matchesInit: "matches/setInit",
      stadiumsInit: 'stadiums/setInit',
      teamsInit: 'teams/setInit',
      usersInit: 'users/setInit',
      setStatus: 'events/setStatus'
    }),
    create () {
      this.clearOne()
      this.clearOneActs()
      this.action = 'create'
      this.modal = true
      this.edit = true
    },
    update ({ matchId, actId }) {
      this.getOne(matchId)
      this.setOneActByScore({ actId })
      this.action = 'update'
      this.edit = true
      this.modal = true
    },
    remove ({ matchId, actId }) {
      this.getOne(matchId)
      this.setOneActByScore({ actId })
      this.action = 'remove'
      this.edit = false
      this.modal = true
    },
    view ({ matchId, actId }) {
      this.getOne(matchId)
      this.setOneActByScore({ actId, matchId })
      this.viewModal = true
    },
    close () {
      this.modal = false
      this.clearOne()
    },
    closeView () {
      this.viewModal = false
    },
    async initData () {
      await Promise.all([
        // this.matchesInit(),
        this.aspectsInit(),
        this.actsInit(),
        this.entitiesInit(),
        this.tournamentsInit(),
        this.stadiumsInit(),
        this.teamsInit(),
        this.usersInit()
      ])
    }
  },
  watch: {
    statusOfButton: function (val) {
      // if (val) this.initData().finally(() => this.setStatus(false));
    }

  }
}
</script>
